import React from 'react';

export type BadgeVariant = 'info';

export interface BadgeProps {
  label: string;
  variant?: BadgeVariant;
}

const Badge = ({ label, variant = 'info' }: BadgeProps) => (
  <span className={`ds-badge ds-badge--${variant}`}>{label}</span>
);

export default Badge;
